import React from 'react';

interface JurisprudenceResultItemProps {
    result: {
        summary?: string;
        number?: string;
        decision_date?: string;
        jurisdiction?: string;
        chamber?: string;
        solution?: string;
        id?: string;
        location?: string;
        enhancedScore?: number;
        scoreBreakdown?: {
            exactMatch: number;
            jurisdictionMatch: number;
            recency: number;
            textRelevance: number;
            judilibreScore: number;
        };
        relevanceTier?: 'high' | 'medium' | 'low';
    };
    title: string;
    onClick: () => void;
}

const JurisprudenceResultItem: React.FC<JurisprudenceResultItemProps> = ({ result, title, onClick }) => {
    const isCourDeCassation = result.jurisdiction === 'Cour de cassation';

    return (
        <div
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
            className="p-3 hover:bg-mcdm-primary-200 dark:hover:bg-mcdm-third-300 cursor-pointer rounded-lg border border-mcdm-primary-200 dark:border-mcdm-primary-200 transition-all duration-200 hover:shadow-md"
        >
            {/* Header avec titre */}
            <div className="mb-2">
                {!isCourDeCassation && (
                    <div className="font-medium font-platypi text-mcdm-third-500 dark:text-mcdm-primary-100">
                        {title}
                    </div>
                )}
                {isCourDeCassation && (
                    <div className="font-medium font-platypi text-mcdm-third-500 dark:text-mcdm-primary-100">
                        {result.decision_date || 'Date inconnue'} - {result.jurisdiction || 'Juridiction inconnue'} {result.number ? `n° ${result.number}` : ''}
                    </div>
                )}
            </div>

            {/* Résumé si disponible */}
            {result.summary && (
                <div className="mb-2 text-sm text-gray-700 dark:text-gray-300">
                    <strong>Résumé : </strong>
                    {result.summary}
                </div>
            )}

            {/* Métadonnées en grille */}
            {isCourDeCassation ? (
                <div className="grid grid-cols-2 gap-2">
                    <span className="text-left bg-mcdm-primary-100 dark:bg-mcdm-third-500 text-mcdm-third-400 dark:text-mcdm-primary-100 px-2 py-1 rounded text-sm shadow">
                        Numéro : {result.number || 'N/A'}
                    </span>
                    <span className="text-left bg-mcdm-primary-100 dark:bg-mcdm-third-500 dark:text-mcdm-primary-100 px-2 py-1 rounded text-sm shadow">
                        Date : {result.decision_date || 'N/A'}
                    </span>
                    <span className="text-left bg-mcdm-primary-100 dark:bg-mcdm-third-500 dark:text-mcdm-primary-100 px-2 py-1 rounded text-sm shadow">
                        Juridiction : {result.jurisdiction || 'N/A'}
                    </span>
                    <span className="text-left bg-mcdm-primary-100 dark:bg-mcdm-third-500 dark:text-mcdm-primary-100 px-2 py-1 rounded text-sm shadow">
                        Chambre : {result.chamber || 'N/A'}
                    </span>
                    <span className="text-left bg-mcdm-primary-100 dark:bg-mcdm-third-500 dark:text-mcdm-primary-100 px-2 py-1 rounded text-sm shadow col-span-2">
                        Solution : {result.solution || 'N/A'}
                    </span>
                </div>
            ) : (
                <div className="grid grid-cols-2 gap-2">
                    <span className="text-left bg-mcdm-primary-100 dark:bg-mcdm-third-500 dark:text-mcdm-primary-100 px-2 py-1 rounded text-sm shadow">
                        Numéro : {result.number || 'N/A'}
                    </span>
                    <span className="text-left bg-mcdm-primary-100 dark:bg-mcdm-third-500 dark:text-mcdm-primary-100 px-2 py-1 rounded text-sm shadow">
                        Date : {result.decision_date || 'N/A'}
                    </span>
                    <span className="text-left bg-mcdm-primary-100 dark:bg-mcdm-third-500 dark:text-mcdm-primary-100 px-2 py-1 rounded text-sm shadow">
                        Juridiction : {result.jurisdiction || 'N/A'}
                    </span>
                    <span className="text-left bg-mcdm-primary-100 dark:bg-mcdm-third-500 dark:text-mcdm-primary-100 px-2 py-1 rounded text-sm shadow">
                        Chambre : {result.chamber || 'N/A'}
                    </span>
                </div>
            )}
        </div>
    );
};

export default JurisprudenceResultItem;
